/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {PresetItem} from '../models/PresetItem';
import type {SearchPresetRequest} from '../models/SearchPresetRequest';

export interface SearchForAll$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchForAllRequest = createAction<PayloadData<void>>('ENTITLEMENTS_PRESET_SEARCH__SEARCH_FOR_ALL__REQUEST');
export const searchForAllSuccess = createAction<PayloadData<Array<PresetItem>>>('ENTITLEMENTS_PRESET_SEARCH__SEARCH_FOR_ALL__SUCCESS');
export const searchForAllFailure = createAction<PayloadData<Error, void, true>>('ENTITLEMENTS_PRESET_SEARCH__SEARCH_FOR_ALL__FAILURE');

export const searchForAllActions = [
    searchForAllRequest,
    searchForAllSuccess,
    searchForAllFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchForAll = (config?: SearchForAll$Config) => {
    return {
        CALL_API: {
            types: searchForAllActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/presets/search`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface SearchPresets$Request {
    searchPresetRequest: SearchPresetRequest;
}

export interface SearchPresets$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchPresetsRequest = createAction<PayloadData<void, SearchPresets$Request>>('ENTITLEMENTS_PRESET_SEARCH__SEARCH_PRESETS__REQUEST');
export const searchPresetsSuccess = createAction<PayloadData<Array<PresetItem>, SearchPresets$Request>>('ENTITLEMENTS_PRESET_SEARCH__SEARCH_PRESETS__SUCCESS');
export const searchPresetsFailure = createAction<PayloadData<Error, SearchPresets$Request, true>>('ENTITLEMENTS_PRESET_SEARCH__SEARCH_PRESETS__FAILURE');

export const searchPresetsActions = [
    searchPresetsRequest,
    searchPresetsSuccess,
    searchPresetsFailure
] as const;

/**
 * @param {SearchPresetRequest} meta.searchPresetRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchPresets = (meta: SearchPresets$Request, config?: SearchPresets$Config) => {
    return {
        CALL_API: {
            types: searchPresetsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/presets/search`,
            TRANSPORT_REQUEST_BODY: meta.searchPresetRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

